module.exports = __webpack_public_path__ + "img/pocket_back_width.2220def6.png";